<!--
 * @Author: wsx
 * @Date: 2022-01-12 11:12:43
 * @LastEditTime: 2022-06-13 10:41:36
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:用户管理
-->
<template>
  <el-container class="UserManage">
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="deptId"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <h-unfold @refreshTableEmit="refreshTable()">
          <template #type>
            <el-input
              v-model="tableParams.userName"
              placeholder="用户名"
              :style="{ width: '300px' }"
              clearable
            ></el-input>
          </template>
          <el-form-item label="用户名" prop="userName">
            <el-input
              v-model="tableParams.userName"
              placeholder="用户名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="tableParams.name"
              placeholder="姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="tableParams.sex" placeholder="性别" clearable>
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="IDCard">
            <el-input
              v-model="tableParams.IDCard"
              placeholder="身份证号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roleId">
            <el-select
              v-model="tableParams.roleId"
              placeholder="角色"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="tableParams.status"
              placeholder="状态"
              clearable
            >
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item>
        </h-unfold>
        <el-row>
          <el-col>
            <h-button
              type="primary"
              :disabled="parentIdD.includes(tableParams.deptId)"
              @click="addButton"
              >添加</h-button
            >
            <h-button type="danger" @click="delUser">删除</h-button>
            <h-button type="primary" @click="uploade">导入</h-button>
            <h-button type="primary" @click="exporting">导出</h-button>
            <h-button type="primary" @click="download">模板下载</h-button>
            <input type="file" v-show="false" ref="file" @change="myup" />
            <h-button
              type="primary"
              @click="resetPasswordFn"
              :style="{ 'margin-left': '10px' }"
              >重置密码</h-button
            >
            <!-- <h-button type="danger" @click="disableAccount">停用</h-button> -->
            <h-button type="primary" @click="toconFigure">配置</h-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="queryUserList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #role="{ row }">
            <div
              class="table-role"
              v-for="item in row.roleList"
              :key="item.roleId"
            >
              {{ item.roleName }}
            </div>
          </template>
          <template #status="{ row }">
            <el-switch
              :value="row.status"
              :active-value="'1'"
              :inactive-value="'0'"
              style="
                --el-switch-on-color: #13ce66;
                --el-switch-off-color: #ff4949;
              "
              @change="handelUserStatus(row, val)"
            >
            </el-switch>
            <span style="margin-left: 8px">{{ row.statusDict }}</span>
          </template>
        </h-table>
      </div>
    </el-card>
    <user-form
      v-if="formVisible"
      v-model="formVisible"
      v-model:form="userFormData"
      v-model:modelValues="modelValues"
      :status="formStatus"
      @submit="userSubmit"
    ></user-form>
    <import-dialog v-model="importVisible" @submit="userSubmit"></import-dialog>
    <el-dialog title="配置" width="400px" v-model="toconFigureVisible">
      <div
        style="display: flex; margin-bottom: 20px"
        v-for="(item, index) in dictList"
        :key="index"
      >
        <el-checkbox
          true-label="true"
          false-label="false"
          label
          v-model="item.remark"
        ></el-checkbox>
        <div style="width: 100px; text-align: right; line-height: 30px">
          字段名 {{ index + 1 }}：
        </div>
        <el-input v-model="item.value" placeholder></el-input>
      </div>
      <template #footer>
        <el-button @click="toconFigureClick">确定</el-button>
        <el-button @click="toconFigureVisible = false">取消</el-button>
      </template>
    </el-dialog>
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watch,
  ref,
  h,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { queryOrganList } from "@/api/system";
import {
  deleteUser,
  resetPassword,
  stopUser,
  queryUserList,
  saveStatus,
} from "@/api/user";
import userForm from "./components/userForm.vue";
import importDialog from "./components/importDialog.vue";
import { getRoleSelect } from "@/api/system/role";
import util from "@util/js";
import { getDict, dictUpdate } from "@/api/constant";
import { uploaduser, deriveuser, downloaduser } from "@/api/system/region.js";
import _ from "lodash";
export default defineComponent({
  name: "UserManage",
  components: { userForm, importDialog },
  props: {},
  setup(props) {
    const state = reactive({
      dictList: [],
      parentIdD: "",
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      sexs: { 1: "男", 2: "女" },
      currentNode: {},
      importVisible: false,
      formVisible: false,
      modelValues: true,
      toconFigureVisible: false,
      formStatus: 1, // 1 添加  2 编辑
      userFormData: {},
      dataSource: [],
      tableData: [],
      tableSelection: [],
      tableParams: {
        hasSonDept: true,
        deptId: "",
        name: "",
        sex: "",
        card: "",
        roleId: "",
        status: "",
        username: "",
      },
      options: [],
      columns: [
        { type: "selection" },
        {
          label: "用户名",
          prop: "username",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "性别",
          prop: "sexDict",
          width: "80",
        },
        {
          label: "角色",
          hidden: true,
          slot: "role",
        },
        {
          label: "身份证号",
          prop: "card",
        },
        {
          label: "部门",
          prop: "deptName",
        },
        {
          label: "状态",
          slot: "status",
          width: "150px",
        },
        {
          label: "手机号",
          prop: "phoneNum",
        },
        {
          label: "员工号",
          prop: "jobNum",
        },

        {
          type: "operate",
          label: "操作",
          width: "150px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "详情", emitKey: "info" },
            { name: "删除", emitKey: "del", type: "danger" },
            { name: "重置密码", emitKey: "resetPassword" },
          ],
        },
      ],
    });
    const file = ref();
    const refData = toRefs(state);
    const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 组织树的筛选
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );

    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      console.log(item, 55555);
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };

    // 获取角色列表
    const getRoleSelectAsync = async () => {
      const res = await getRoleSelect();
      state.options = res.list;
    };
    getRoleSelectAsync();
    // 递归
    const cc = (list, arr) => {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.deptId === Number(localStorage.getItem("userDeptId"))) {
          return arr;
        } else {
          arr.push(element.deptId);
          if (element.children.length) {
            return cc(element.children, arr) || [];
          }
        }
      }
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await queryOrganList();
      const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = treeData;
      state.parentIdD = cc(treeData, []);
      console.log(state.dataSource);
      console.log(state.parentIdD);
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.deptId;
          treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };

    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    queryOrganTreAsync();
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      console.log(operate, row, 8888888888);
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.userFormData.roleIdList = row.roleList.map((item) => item.roleId);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.userId]);
          },
          () => {}
        );
      } else if (emitKey === "resetPassword") {
        ElMessageBox({
          title: "重置密码",
          message: h("p", null, [
            h("p", null, "您确认要将该用户密码重置为默认密码吗？"),
            h("p", null, "默认密码：a123456"),
          ]),
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }).then(
          () => {
            resetPasswordAsync([row.userId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.userId);
            deleteUserAsync(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的用户",
        });
      }
    };
    const deleteUserAsync = async (ids) => {
      const res = await deleteUser(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量重置密码
    const resetPasswordFn = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox({
          title: "重置密码",
          message: h("p", null, [
            h("p", null, "您确认要将选中用户密码重置为默认密码吗？"),
            h("p", null, "默认密码：a123456"),
          ]),
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.userId);
            resetPasswordAsync(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要重置密码的用户",
        });
      }
    };
    const resetPasswordAsync = async (ids) => {
      const params = {
        ids: ids,
      };
      const res = await resetPassword(params);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "密码重置成功",
        });
      }
    };
    // 停用账号
    const disableAccount = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox({
          title: "重置密码",
          message: "您确认要将选中用户停用吗？",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.userId);
            stopUserAsycn(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要停用的用户",
        });
      }
    };
    const stopUserAsycn = async (ids) => {
      const res = await stopUser(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "修改成功",
        });
      }
    };
    //更新用户状态
    const handelUserStatus = async (row) => {
      ElMessageBox.confirm("您确认要修改当前用户状态吗？", "修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          if (row.userId == "1") return;
          const params = {
            status: row.status,
            userId: row.userId,
          };
          const res = await saveStatus(params);
          if (res.code === 0) {
            refreshTable();
            ElMessage({
              type: "success",
              message: "修改成功",
            });
          }
        },
        () => {}
      );
    };

    // 导出数据
    const exporting = async () => {
      const params = {
        page: 1,
        limit: 20,
      };
      const res = await deriveuser(params);
      console.log(res);
      const fileName = `${"用户管理导入模板"}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    // 导入数据
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据
      console.log(file.name);
      // if (file.name.substring(11, 15) !== "xlsx") {
      //   state.flag = true;
      // } else {
      const result = await uploaduser(param);
      console.log("result", result);
      if (result.code == 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "上传成功",
        });
      }
      // }
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "用户管理导入模板.xlsx");
    };
    // 配置
    const toconFigure = () => {
      state.toconFigureVisible = true;
    };
    const getDictAxios = async () => {
      const res = await getDict("back_up_field");
      state.dictList = res.dict;
    };
    getDictAxios();
    const toconFigureClick = async () => {
      state.dictList.forEach(async (item) => {
        await dictUpdate(item);
      });
      state.toconFigureVisible = false;
      ElMessage({
        type: "success",
        message: "修改成功",
      });
      getDictAxios();
    };

    return {
      ...refData,
      toconFigureClick,
      refreshTable,
      toconFigure,
      treeRef,
      formRef,
      tableRef,
      filterNode,
      currentChange,
      hzTableSelect,
      handleClick,
      queryUserList,
      resetForm,
      userSubmit,
      delUser,
      resetPasswordFn,
      disableAccount,
      addButton,
      file,
      uploade,
      myup,
      download,
      exporting,
      handelUserStatus,
    };
  },
});
</script>
<style lang="scss" scoped>
.UserManage {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        background-color: var(--el-color-info-lighter);
        box-sizing: border-box;
        border-color: transparent;
        border-radius: 5px;
        margin: 2px 0 2px 6px;
        text-align: center;
      }
    }
  }
}
</style>
